const prepareAttachments = attachments => attachments.map(attachment => attachment.uploadedFile);

export default prepareAttachments;
